"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownList = void 0;
var dropdown_list_1 = require("@csod/dropdown-list");
Object.defineProperty(exports, "DropdownList", { enumerable: true, get: function () { return dropdown_list_1.DropdownList; } });

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["DropdownList"] = undefined;


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/DropdownList/DropdownList.js
// module id = 67
// module chunks = 0 1